import { header } from '../../portfolio'
import Navbar from '../Navbar/Navbar'
import './Header.css'

const Header = () => {
  const { homepage, title } = header

  return (
    <header className='header center'>
      <div className="container">
        {homepage ? (
          <a href={homepage} className='logo'>
            <img src="images/eugene-shatskih.png" alt="Eugene Shatskih" />
          </a>
        ) : (
          <img src="images/eugene-shatskih.png" alt="Eugene Shatskih" />
        )}
        <Navbar />
      </div>
    </header>
  )
}

export default Header
